import React, { Component } from 'react';
import {IssueStyle} from './Style.js'

export default class Spread extends Component {

	static defaultProps = {
		bottomMenuOpen: true,
		issueIndexOpen: false,
		margin: 20,
	}

	page_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	page_height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	isZoom = false;
	tp = null;
	scale = 1;
	mounted = false;
	animateZoom = true;
	bounds = {};
	mouseDownX = 0;
	mouseDownY = 0;
	startX = 0;
	startY = 0;
	cx = 0;
	cy = 0;

	constructor(props)
	{
		super(props);
		this.double = props.children.length > 1;
		this.state = {
			pageSize: props.pageSize,
			// backgroundColor: getRandomColor()
		}
	}
	
	componentDidMount(){	
		window.addEventListener("resize", this.update.bind(this));
		window.addEventListener('mouseup', this.onMouseUp.bind(this));
		setTimeout(() => this.mounted = true, 1000);
	}
	
	componentWillUnmount() {
		this.mounted = false;
		window.removeEventListener("resize", this.update.bind(this));
		window.removeEventListener('mouseup', this.onMouseUp.bind(this));
	}

	setZoomAnimation(animateZoom){
		this.animateZoom = animateZoom;
	}

// 	shouldComponentUpdate(nextProps, nextState) {
// 		const {visible:newVisible, style: newStyle} = nextProps;
// 		const {scale:newScale} = nextState;

// 		const {visible, index, style} = this.props;
// 		const {scale} = this.state;

// 		if(scale !== newScale)
// 			return true;

// 		if(style !== newStyle)
// 			return true;
	
// 		if(newVisible !== visible)
// 			return true;

// 		return false;
//   }

	update(){
		this.forceUpdate();
	}

	getCurrentPageHeight() {
		const {bottomMenuOpen, issueIndexOpen} = this.props;
		const {bottomMenuHeight, issueIndexHeight} = IssueStyle;

		let h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		
		if(bottomMenuOpen)
			h -= bottomMenuHeight;
		
		if(issueIndexOpen)
			h -= issueIndexHeight

		return h;
	}

	getCurrentPageWidth(){
		return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	}

	getFullPageScale(){
		const {bottomMenuOpen} = this.state;

		this.page_width = this.getCurrentPageWidth();
		this.page_height = this.getCurrentPageHeight();
		const {margin} = this.props;
		const {width, height} = this.state.pageSize;
		const spreadWidth = width * 2;
		const spreadHeight = height;
		
		const PAGE_WIDTH_MARGIN = this.page_width - margin * 2;
		const PAGE_HEIGHT_MARGIN = this.page_height - margin * 2;

		let scale_to_fit_width = 1;
		let scale_to_fit_height = 1;
		
		scale_to_fit_width = PAGE_WIDTH_MARGIN / spreadWidth;
		scale_to_fit_height = PAGE_HEIGHT_MARGIN / spreadHeight;

		const scale = Math.min(scale_to_fit_width, scale_to_fit_height);

		return scale;
	}
	
	getScale(){
		// const {visible} = this.props;
		
		// if(!visible)
		// 	return null;

		this.page_width = this.getCurrentPageWidth();
		this.page_height = this.getCurrentPageHeight();

		const {margin} = this.props;
		const {width, height} = this.state.pageSize;
		const spreadWidth = width * 2;
		const spreadHeight = height;
		
		const PAGE_WIDTH_MARGIN = this.page_width - margin * 2;
		const PAGE_HEIGHT_MARGIN = this.page_height - margin * 2;

		let scale_to_fit_width = 1;
		let scale_to_fit_height = 1;

		if(this.isZoom) // we are zooming so set the scale to fit one page width to full screen
		{
			scale_to_fit_width = PAGE_WIDTH_MARGIN / width;	

			return Math.min(scale_to_fit_width, 1);
		}
		
		// we are not zooming so fit spread on single screen
		
		scale_to_fit_width = PAGE_WIDTH_MARGIN / spreadWidth;
		scale_to_fit_height = PAGE_HEIGHT_MARGIN / spreadHeight;

		const scale = Math.min(scale_to_fit_width, scale_to_fit_height);

		return scale;
	}

	zoom(coords = null){
	
		this.isZoom = !this.isZoom;

		if(this.isZoom && !!coords){
			this.getTransformCoords(coords);
		}
		else {
			// todo m.t.
		}

		this.forceUpdate();
	}

	zoomOut(){
		this.isZoom = false;
		this.forceUpdate();
	}

	getTransformFromClickCoords(coords){
		const {clientX,clientY} = coords;
		const x = clientX;
		const y = clientY;
		
		return {x,y};
	}

	onMouseDown(e){
		if(!this.mounted)
			return;

		this.mouseDown = true;
		this.mouseDownX = e.clientX;
		this.mouseDownY = e.clientY;

		let {tp} = this;

		if(!tp)
			return;

		tp.ox = tp.x;
		tp.oy = tp.y;

		this.tp = tp;
	}

	onMouseUp(e){
		if(!this.mounted)
			return;

		this.mouseDown = false;
		let {tp} = this;
		
		if(!tp)
			return;

		tp.ox = tp.x;
		tp.oy = tp.y;
		this.tp = tp;

		this.forceUpdate();
	}

	onMouseMove(e){
		if(!this.mounted)
			return;
			
		if(!this.mouseDown)
			return;
		
		if(!this.isZoom)
			return;

		if(!this.tp)
			return;

		this.setZoomAnimation(false)

		const {clientX,clientY} = e;
		let {bounds, tp} = this;

		const dX = this.mouseDownX - clientX;
		const dY = this.mouseDownY - clientY;

		const tpDx = tp.ox - dX;
		const tpDy = tp.oy - dY;


		this.tp = {
			x: tpDx >= bounds.minX ? bounds.minX : (tpDx < bounds.maxX ? bounds.maxX : tpDx),
			y: tpDy <= bounds.minY ? bounds.minY : (tpDy > bounds.maxY ? bounds.maxY : tpDy),
			ox: tp.ox,
			oy: tp.oy
		}
		this.forceUpdate();
	}

	getTransformCoords(coords = null){
		
		let scale = !!coords ? this.getScale() : this.scale;

		const {width, height} = this.state.pageSize;
		const {margin} = this.props;
		const {double} = this;
		let {tp} = this;
		const scaledHeight = height * scale;
		const scaledWidth = double ? width * scale : width * scale;
		
		this.page_width = this.getCurrentPageWidth();
		this.page_height = this.getCurrentPageHeight();

		if(this.isZoom){
			const startX = !double ? 
				this.page_width/2 - (width/2) :
				this.page_width/2 - (width);

			const startY = this.page_height/2 - (height/2);

			// const minX = startX + (this.page_width/2) - margin;
			// const maxX = startX - (this.page_width/2) + margin;

			const maxX = startX + ((this.page_width - (scaledWidth*2))/2) - margin;
			const minX = startX - ((this.page_width - (scaledWidth*2))/2) + margin;

			const minY = startY + ((this.page_height - (scaledHeight))/2) - margin;
			const maxY = startY - ((this.page_height - (scaledHeight))/2) + margin;
			
			this.bounds = {minX, maxX, minY, maxY, startX, startY};

			// const dX = Math.abs(maxX - minX);
			// const dY = Math.abs(maxY - minY);
			
			if(!!coords && !!coords.clientX )
			{
				const {clientX, clientY} = coords;
				
				// const px = clientX / this.page_width
				// const py = clientY / this.page_height
				
				const fsScale = this.getFullPageScale();
				const tHeight = height * fsScale;
				const tMarginTop = (this.page_height - tHeight)/2;
				const ty = clientY - tMarginTop;
				const opcy = ty / fsScale // original page click y (height);
				const spcy = opcy * scale; // scaled page click y 

				const tWidth = (width*2) * fsScale;
				const tMarginLeft = (this.page_width - tWidth)/2;
				const tx = clientX - tMarginLeft;
				const opcx = tx / fsScale // original page click y (width);
				const spcx = opcx * scale; // scaled page click x

				// const toTransformY = (startY - ((ty/tHeight) * -dY));
				const toTransformY = Math.max(minY, maxY) - spcy - margin + (clientY);
				const toTransformX = Math.max(minX, maxX) - spcx - margin + (clientX);

				tp = {
					x: toTransformX,
					y: ty < 0 ? Math.max(minY, maxY) : (ty > tHeight ? Math.min(minY, maxY) : toTransformY)
				}
				this.tp = tp;
			}
			else if(!tp)
			{
				tp = {
					x: startX,
					y: startY
				}
			}
			else if(!coords && !!tp)
			{
				// tp = {
				// 	x: startX,
				// 	y: startY
				// }
			}
			

			tp.x = tp.x >= minX ? minX : (tp.x < maxX ? maxX : tp.x)
			tp.y = tp.y <= minY ? minY : (tp.y > maxY ? maxY : tp.y)

			const translatedX = !double ? startX : tp.x;
			const translatedY = tp.y
			
			return {translateX : translatedX, translateY: translatedY, scale};
		}

		const translateX = !this.double ? 
			this.page_width/2 - (width/2) :
			this.page_width/2 - (width);

		const translateY = this.page_height/2 - (height/2)

		this.bounds = {startX: translateX, startY: translateY};

		this.startX = translateX;
		this.startY = translateY;

		return {translateX, translateY, scale};
	}
	
	resetCoords(){
		const {startX, startY} = this;
		this. tp = {
			x: startX,
			y: startY
		}
		
	}

	getTransform(){
		const {translateX, translateY, scale} = this.getTransformCoords();
		return `translateX(${translateX}px) translateY(${translateY}px) scale(${scale}) translateZ(0)`;
	} 
	
	render() {

		const spreadPageStyle = {
			width: '100%',
			height: '100%',
			position: 'absolute',
			display: 'block',
		}

		const scale = this.getScale();
		this.scale = scale;

		const {width, height} = this.state.pageSize;
		const {double, animateZoom} = this;
		const {backgroundColor} = this.state;
		const transform = this.getTransform();
		const {style, className, single} = this.props;


		const localStyle = {
			color: '#999',
			transform,
			transition: animateZoom ? 'transform 0.16s ease-out' : null,
			width: double ? `${(width * 2)}px` : `${width}px`,
			height,
		}

		if(single)
			console.log({localStyle})

		const spreadStyle = {
			transformOrigin: `center center`,
			boxShadow: '0px 2px 10px rgba(0,0,0,0.3)'
		};

		return (
			<div className={className} style={{...style, ...spreadPageStyle, backgroundColor}}>
				<div
					draggable={false}
					onMouseDown={this.onMouseDown.bind(this)}
					onMouseMove={this.onMouseMove.bind(this)}
					onMouseUp={this.onMouseUp.bind(this)}
					style={{...spreadStyle, ...localStyle}} >
					{this.props.children}
				</div>
			</div>
			)
		}
	}
	